import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LoanPurposeType } from '../Models/EnumHelper';
import { UserAddressModel, UserProfileModel } from '../Models/user-data.model';

@Injectable({
  providedIn: 'root'
})
export class CommonHelperService {
  PurposeTypeEnum = LoanPurposeType;
  
  constructor(private router: Router) {
  }  

  SetPersonalDetails(personalDetail: UserProfileModel){
    sessionStorage.setItem('personalDetail', JSON.stringify(personalDetail));
  }

  GetPersonalDetail(): UserProfileModel | null {
  const data = sessionStorage.getItem("personalDetail");
  if (data !== null) {
    return JSON.parse(data) as UserProfileModel;
  }
  return null;
}

  GetLoanType(purposeType: number): string {
    let loanType: string;
    switch (purposeType) {
      case this.PurposeTypeEnum.CarLoan:
        loanType = 'Car Loan';
        break;
      case this.PurposeTypeEnum.DebtConsolidation:
        loanType = 'Debt Consolidation';
        break;
      case this.PurposeTypeEnum.HomeImprovements:
        loanType = 'Home Improvements';
        break;
      case this.PurposeTypeEnum.Others:
        loanType = 'Others';
        break;
      default:
        loanType = '';
        break;
    }
    return loanType;
  }
}
